// extracted by mini-css-extract-plugin
export var alternate = "_d-h";
export var black = "_d-3";
export var blue = "_d-d";
export var blueLight = "_d-c";
export var brand = "_d-7";
export var error = "_d-9";
export var gray = "_d-6";
export var grayBlue = "_d-b";
export var iconWrapper = "_d-4";
export var indigo = "_d-e";
export var orange = "_d-g";
export var pink = "_d-f";
export var primary = "_d-0";
export var purple = "_d-8";
export var success = "_d-5";
export var warning = "_d-a";
export var white = "_d-1";
export var whiteSuccess = "_d-2";